<template>
  <div class="animated fadeIn form-abm">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información de la Etapa">
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                class="text-upper"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Inicio"
              label-for="fechaInicio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaInicio" 
                v-model="fechaInicio" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Fin"
              label-for="fechaFin"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaFin" 
                v-model="fechaFin" 
                type="date">
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { msjAlert } from '../../mixins/msjAlert';
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'eventoEtapa/getField',
  mutationType: 'eventoEtapa/updateField',
});

export default {
  name: 'EventoEtapaABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal,
    msjAlert
  ],
  data () {
    return {
      eventoEtapaId: 0,

      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'fechaInicio',
      'fechaFin',
    ]),
  },  
  created() {
    let eventoEtapaId = 0;
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
      if (this.$route.params.id){
        eventoEtapaId = this.$route.params.id;
      }
    }

    let params = {
      eventoId: this.eventoId,
      eventoEtapaId
    }

    this.showSpinner();
    this.$store.dispatch('eventoEtapa/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del participante.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          let leyenda = 'La información de la etapa se registró con éxito';
          if (this.id != 0) {
            leyenda = 'Los cambios se registraron con éxito';
          }
          this.showSpinner();
          this.$store.dispatch('eventoEtapa/save')
            .then(()  => this.showModalMsj(leyenda, this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    goList() {
      this.$router.push({ name: 'EventosEtapas', 
                          params: { eventoId: this.eventoId }});
    },
  },
  watch: {
  },
  validations: {
    nombre: {
      required: requiredIf(function () {
        return (/true/i).test(this.eventoRequiereNombre);
      }),
      maxLength: maxLength(255)
    },
  },  
}
</script>

<style>
</style>
